import * as React from 'react';
import { FC, useEffect } from 'react';

import { styled } from '../theme';
import { FlexRow, PageCard } from './';

type Props = {
    withTabs?: boolean;
    noHeaderSpacing?: boolean;
    noPadding?: boolean;
    headerHeight?: number;
    noScrolling?: boolean;
    transparentSurface?: boolean;
    innerRef?: any;
    children?: React.ReactNode;
    id?: string;
    onMountedChange?: (boolean) => void;
};

const TABS_HEIGHT = 50;

const SpaceUnderPageHeader = styled(FlexRow)<Props>(
    ({ noHeaderSpacing, headerHeight = 100, withTabs }) => ({
        width: '100%',
        minHeight: noHeaderSpacing ? 0 : withTabs ? headerHeight + TABS_HEIGHT : headerHeight,
    })
);

const Container = styled('section')<Props>(({ theme, noPadding, noScrolling }) => {
    const padding = noPadding ? 0 : 15;
    const mdPadding = padding * 2;

    return {
        width: '100%',
        flexGrow: 1,
        background: theme.color.backgroundGray,
        overflowY: noScrolling ? 'unset' : 'auto',
        display: 'flex',
        flexFlow: 'column',
        padding: padding,
        paddingTop: mdPadding,
        [theme.breakpoint.md]: {
            padding: mdPadding,
            paddingTop: mdPadding,
        },
    };
});

const PageBody: FC<Props> = ({
    onMountedChange,
    children,
    transparentSurface,
    innerRef,
    ...restProps
}) => {
    const { noHeaderSpacing, headerHeight, withTabs } = restProps;

    useEffect(() => {
        onMountedChange?.(true);
        return () => {
            onMountedChange?.(false);
        };
    });

    return (
        <>
            <SpaceUnderPageHeader {...{ noHeaderSpacing, headerHeight, withTabs }} />
            <Container ref={innerRef} {...restProps} data-testid="page-body">
                <PageCard transparentSurface={transparentSurface}>{children}</PageCard>
            </Container>
        </>
    );
};

export default PageBody;
